import { createFileRoute, Outlet } from "@tanstack/react-router";
import ProtectedRoute from "../components/ProtectedRoute";
import Paywall from "../components/Paywall";
import { usePaywall } from "../hooks/usePaywall";

export const Route = createFileRoute("/labs")({
  component: LabsLayout,
});

function LabsLayout() {
  const { isPaywallVisible, setIsPaywallVisible } = usePaywall();
  return (
    <ProtectedRoute>
      {isPaywallVisible && <Paywall onClose={() => setIsPaywallVisible(false)} />}
      <Outlet />
    </ProtectedRoute>
  );
}
